'use client';

import { useRouter } from 'next/navigation';
import { Button } from "../ui/button";
import { useScheduleDemo } from "@/context/schedule-demo-context";

type Props = {
  /** Page whose contact section hosts the scheduler; the homepage by default. */
  href?: string;
  label?: string;
};

export default function BlogCta({ href = '/', label = 'Book Your Personalized Demo' }: Props) {
    const { showDemoScheduler } = useScheduleDemo();
    const router = useRouter();

    const handleBookDemoClick = () => {
        // Navigate client-side to the page that carries the contact section, then open
        // the scheduler once that section is in the DOM.
        router.push(href);

        setTimeout(() => {
            const contactSection = document.getElementById('contact');
            if (contactSection) {
                contactSection.scrollIntoView();
            }
            showDemoScheduler();
        }, 100); // 100ms is usually enough time.
    };

    return (
        <Button size="lg" onClick={handleBookDemoClick}>{label}</Button>
    )
}
